import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { UserService } from './user.service';
import { catchError } from 'rxjs/operators';
import { UserModel } from './user-model';
import { Page } from 'src/app/shared/models/paging/page';
import { ReturnResult } from 'src/app/shared/models/return-result';

@Injectable()
export class UserResolveService implements Resolve<UserModel[]>{
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): UserModel[] |
    Observable<UserModel[]> |
    Promise<UserModel[]> {
    return this.userService.getUserPaging(new Page()).pipe(catchError(error => {
      console.log(error);
      return of(error);
    }));
  }

  constructor(private userService: UserService) { }

}

@Injectable()
export class GetAllUserResolver implements Resolve<ReturnResult<UserModel[]>>{
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return this.userService.getAllUserModel().pipe(catchError(error => {
      console.log(error);
      return of(error);
    }));
  }

  constructor(private userService: UserService) { }
}

@Injectable()
export class GetAllMyEmployeeResolver implements Resolve<ReturnResult<UserModel[]>>{
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    return this.userService.getMyEmployee().pipe(catchError(error => {
      console.log(error);
      return of(error);
    }));
  }

  constructor(private userService: UserService) { }
}